<template>
  <div>
    <!--    small-->
    <div class="grouper-header bg-white d-block d-sm-none">
      <div class="row mx-2">
        <div style="width:60px;height:60px" @click="setAvatar('picInput')" class="avatar-box mr-2">
          <i class="el-icon-camera-solid"
             v-if="$store.state.user.userinfo && $store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6"></i>
          <router-link :to="'/group/index/'+$store.state.group.groupTopBar.id">
            <el-avatar v-if="groupState.groupInfo.name" shape="square" :src="groupState.groupInfo.avatar"
                       :size="60"><span
                style="font-size:36px">{{ groupState.groupInfo.name.substring(0, 1).toUpperCase() }}</span>
            </el-avatar>
          </router-link>
          <input
              ref="picInput"
              type="file"
              name="image"
              accept="image/png, image/jpeg"
              @change="setImage"
              style="display:none"
          />
        </div>
        <div v-show="show" v-if="show">
          <VueCropper v-if="imgSrc" ref="cropper" :src="imgSrc" alt="Source Image" preview=".preview"
                      :aspectRatio="1"></VueCropper>
          <div class="d-flex align-items-center">
            <button class="btn btn-simple btn-round btn-primary" @click="saveImage">
              {{ $t('message').setting.accout_avatar_save_btn }}
            </button>
            <button class="btn btn-simple btn-round btn-default ml-3" @click="toggleShow">
              {{ $t('message').setting.accout_cancel_btn }}
            </button>
          </div>
          <div class="preview"/>
        </div>
        <div class="">
          <a v-if="$store.state.user.check_is_wxc_domain()"
             :href="'#'">
            <!--              :href="'https://passport.wenxuecity.com/members/index.php?act=profile&cid='+$store.state.group.groupTopBar.userID.username">-->

            <el-avatar
                class="host"
                :size="36"
                v-for="item in memberList.data.host"
                :key="item.id"
                :data="item">
              <img v-if="item.userinfo_userID.avatar!=''" :src="item.userinfo_userID.avatar">
              <div v-else> {{ item.userinfo_userID.first_letter }}</div>
            </el-avatar>
            <!--           </el-popover>-->
          </a>
          <router-link
              v-else
              :to="'/userindex/'+$store.state.group.groupTopBar.userID">
            <!--           <el-popover-->
            <!--               placement="top-start"-->
            <!--               :width="340"-->
            <!--               trigger="hover"-->
            <!--               :open-delay="600"-->
            <!--           >-->
            <!--             <User-Infor-Card :data="data" type="small">-->
            <!--             </User-Infor-Card>-->
            <el-avatar
                class="host"
                :size="36"
                v-for="item in memberList.data.host"
                :key="item.id"
                :data="item">
              <img v-if="item.userinfo_userID.avatar!=''" :src="item.userinfo_userID.avatar">
              <div v-else> {{ item.userinfo_userID.first_letter }}</div>
            </el-avatar>
            <!--           </el-popover>-->
          </router-link>
        </div>
        <!--      <div class="d-flex">-->
        <div class="float-left">
          <!-- <router-link :to="'/group/user/index'" class="h3 mb-0 font-weight-bold pr-2">-->
          <div class="mb-0">
            <div>
              <router-link style="display: block" :to="'/group/index/'+$store.state.group.groupTopBar.id">
              <span
                  class="float-left text-dark mr-1 grouper-header-title mb-2 font-weight-bold ">
               {{groupState.groupTopBar.name |textTrans }}</span>
              </router-link>
              <div class="d-inline float-left">
                <el-tag class="mr-1 px-1 pt-0 float-left" size="small">群主</el-tag>
                <div v-for="item in memberList.data.host"
                     :key="item.id"
                     style="display: inline-block"
                >{{ item.userinfo_userID.username }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-dropdown trigger="click"
                     v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6"
                     @command="handleCommand">
            <span class="el-dropdown-link group-rule ">
<!--              <el-tooltip content="群吧设置" placement="top" effect="light">-->
               <i size="medium" class="el-icon-s-tools"></i>
              <!--                <span style="margin-left:2px">管理</span>-->
              <!--              </el-tooltip>-->
            </span>
          <el-dropdown-menu slot="dropdown">
            <!--              群主和超管可见-->
            <el-dropdown-item v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6"
                              icon="el-icon-edit" command="1">修改群吧名
            </el-dropdown-item>
            <el-dropdown-item v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6"
                              icon="el-icon-tickets" command="2">修改群吧主题
            </el-dropdown-item>
            <el-dropdown-item v-if="$store.state.group.groupTopBar.auth>=2 || $store.state.user.userinfo.UserLevel==6"
            >
              <el-popconfirm
                  placement="top-end"
                  confirm-button-text='删除'
                  cancel-button-text='取消'
                  title="确定删除这个群吧吗？"
                  class="text-danger"
                  @confirm="removeGroup(groupID)"
              >
                <a href="javascript:void(0)" slot="reference" style="color:gray;display: block">
                  <i class="el-icon-delete"></i>
                  删除群吧
                </a>
              </el-popconfirm>
            </el-dropdown-item>
            <!--              群员和管理员可见-->
            <!--              <el-popconfirm v-if="$store.state.group.groupTopBar.auth==1 || $store.state.group.groupTopBar.auth==2"-->
            <!--                    placement="top-end"-->
            <!--                    confirm-button-text='退出'-->
            <!--                    cancel-button-text='取消'-->
            <!--                    title="确定退出这个群吧吗？"-->
            <!--                    class="text-danger wxc-green"-->
            <!--                    @confirm="removeMember()"-->
            <!--                >-->
            <!--                <el-dropdown-item slot="reference" icon="el-icon-switch-button" class="text-danger"-->
            <!--                  >退出群吧-->
            <!--                </el-dropdown-item>-->
            <!--              </el-popconfirm>-->
            <!--              &lt;!&ndash;              等待审核的用户可见&ndash;&gt;-->
            <!--              <el-dropdown-item icon="el-icon-switch-button" class="text-danger"-->
            <!--                                v-if="$store.state.group.groupTopBar.auth==0"-->
            <!--                                command="0">取消申请-->
            <!--              </el-dropdown-item>-->
            <!--              <el-dropdown-item v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6"-->
            <!--                                icon="el-icon-tickets" command="4">修改群规-->
            <!--              </el-dropdown-item>-->
          </el-dropdown-menu>
        </el-dropdown>

        <!--      <div class="group-rule  flex-fill" @click="groupRuleTrigger=true">-->
        <div class="ml-4"
             v-if="!groupState.groupTopBar.rule=='' || $store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6">
          <div class="group-rule" @click="groupRuleTrigger=true">
            <i class="el-icon-notebook-1 mr-1 trans"></i>
            <!--          <span>{{ $t('message').group.rule }}</span>-->
          </div>
        </div>

        <span class="h5 mb-0 text-secondary" v-if="!groupState.groupTopBar.is_private">
<!--        {{ $t('message').group.group_is_open }}-->
      </span>
        <!--      <span class="h5 mb-0 text-secondary" v-if="groupState.groupTopBar.is_private">-->
        <!--          <i class="el-icon-lock"></i>-->
        <!--           {{ $t('message').group.group_is_private }}-->
        <!--        </span>-->
        <!--        {{-->
        <!--          groupState.groupTopBar.is_private ?   $t('message').group.group_is_open  :  $t('message').group.group_is_private-->
        <!--        }}-->
        <div class="group-member-show h5 mb-0 flex-fill ml-3 mt-2"  style="cursor:pointer" @click="memberListTrigger=true">
        <span>
                       <el-avatar
                           :size="36"
                           v-for="item in memberList.data.member.slice(0,3)"
                           :key="item.id"
                           :data="item"
                       >
                         <img v-if="item.userinfo_userID.avatar!=''" :src="item.userinfo_userID.avatar">
                         <div v-else> {{ item.userinfo_userID.first_letter }} </div>
                        </el-avatar>
          <!--          item.userinfo_id.avatar-->
          <span class="text-secondary">{{
              groupState.groupTopBar.count_member
            }} {{ $t('message').group.group_member_unit }}</span>
        </span>
          <span v-if="has_verify && ($store.state.group.groupTopBar.auth>=2 || $store.state.user.userinfo.UserLevel==6)">
            <el-badge :value="memberList.data.verify.length || 0" class="ite ml-2" type="primary"
                      v-if="memberList.data.verify.length>0">
              <el-button class="p-1" style="font-size:18px;border:none" type="primary" plain>
                <i size="medium" class="el-icon-user-solid"></i>
              </el-button>
            </el-badge>
          </span>
        </div>
        <div class="align-items-right" v-if="$store.state.group.groupTopBar.auth<=0">
          <button v-if="$store.state.group.groupTopBar.auth===-1" type="button" class="btn btn-primary w-100"
                  @click="joniGroup()">
            {{ $t('message').group.group_add }}
          </button>
          <span v-if="$store.state.group.groupTopBar.auth==0" class="h5 text-secondary mr-3">
          <i size="medium" style="font-size:20px" class="el-icon-alarm-clock mr-1"></i> 待审核
        </span>
        </div>
        <div v-if="$store.state.group.groupTopBar.auth>0">
          <button class="post btn btn-primary" icon="el-icon-edit" v-if="!show_editor" @click="show_editor=true">
            <i class="el-icon-edit mr-1" style="font-size:18px"></i>
            <!--          {{ $t('message').topnav.group_editbtn }}-->
          </button>
          <el-button type="default" icon="el-icon-close" v-if="show_editor" @click="cancle">取消</el-button>
        </div>
        <!--      邀请入群-->
        <!--      <div v-if="is_admin">-->
        <!-- <div>
          <el-button type="primary" plain class="ml-2" @click="openAddMemberDialog()" slot="reference">
            <i class="font-weight-bold el-icon-plus"></i> {{ $t('message').group.group_add_member }}
          </el-button>
        </div> -->
        <!--      邀请入群-->
      </div>
      <!-- Editor -->
      <div class="border-bottom groupHeadEditor" v-if="show_editor">
        <wxc-editor :data="{groupinfoID:groupState.groupTopBar.id}" :action="'add'" @submited="updated($event)"
                    @cancled="closeEditor()"></wxc-editor>
      </div>
      <!-- Editor -->
      <!-- member list dialog -->
      <el-dialog
          :title="$t('message').group.member_list_label1"
          :visible.sync="memberListTrigger"
          width="380px"
          center>
        <div style="margin-top:-32px;max-height:500px;overflow-y:auto;margin-top:-32px" v-if="this.memberList.data">
          <!--      <div style="margin-top:-32px" v-if="this.memberList.data">-->
          <div class="py-3 shadow-none"
               v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6">
            <!--          <h4 class="mb-3">邀请群员</h4>-->
            <el-autocomplete class="w-100"
                             popper-class="invite-autocomplete"
                             v-model="inviteUser"
                             :fetch-suggestions="querySearch"
                             :trigger-on-focus="false"
                             :placeholder="$t('message').groupindex.left_btn_add"
                             @select="handleSelect">
              <i class="el-icon-search el-input__icon" slot="prefix">
              </i>
              <template slot-scope="{ item }">
                <div class="d-flex py-2">
                  <el-avatar
                      :src="item.userinfo_id.avatar">
                    {{ item.userinfo_id.first_letter }}
                  </el-avatar>
                  <div class="pl-2">
                    <div class="name">{{ item.userinfo_id.username }}</div>
                    <span class="addr">{{ item.userinfo_id.email }}</span>
                  </div>
                </div>
              </template>
              <el-button class="shadow-none rounded-right invite" slot="append" type="primary"
                         :disabled="inviteUserID===0"
                         @click="inviteMember">
                {{ $t('message').group.group_add_member }}
              </el-button>
            </el-autocomplete>
          </div>
          <!--      <div>-->
          <div>
            <h4 v-if="memberList.data.verify && memberList.data.verify.length>0">
              <!--            <h4 v-if="memberList.data.verify && memberList.data.verify.length>0">-->
              {{ $t('message').group.member_list_label0 }} <span
                style="color:grey;font-size:17px">
           . {{ memberList.data.verify.length || 0 }}
          </span>
            </h4>
            <div
                v-if="has_verify && $store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6">
              <Member-list-item
                  v-for="item in memberList.data.verify"
                  :key="item.id"
                  type="verify"
                  :data="item"
                  @opendialog="$refs.dialog()">
              </Member-list-item>
            </div>
          </div>
          <div>
            <Member-list-item
                v-for="item in memberList.data.host"
                :key="item.id"
                :data="item"
                type="host"
                @opendialog="$refs.dialog()">
            </Member-list-item>
            <Member-list-item
                v-for="item in memberList.data.admin"
                :key="item.id"
                :data="item"
                type="admin"
                @opendialog="$refs.dialog()">
            </Member-list-item>
            <Member-list-item
                v-for="item in memberList.data.member.slice().reverse()"
                :key="item.id"
                :data="item"
                type="member"
                @opendialog="$refs.dialog()">
            </Member-list-item>
          </div>
          <!--        <el-button  plain type="text"  size="small" class="border-0 mx-auto w-100 mt-2" v-if="memberList.data.member.length>1">-->
          <!--         查看更多群员<icon class="ml-2 el-icon-arrow-down"></icon>-->
          <!--        </el-button>-->
          <div v-if="disabled" @click="getMoreMembers" class="text-center" role="button">查看更多群员
            <i class="ml-2 el-icon-arrow-down"></i>

          </div>
          <!--        查找群员-->
          <!--        <div class="py-3 shadow-none"  v-if="memberList.data.member.length>2">-->
          <!--          &lt;!&ndash;          <h4 class="mb-3">邀请群员</h4>&ndash;&gt;-->
          <!--          <el-autocomplete class="w-100"-->
          <!--                           popper-class="invite-autocomplete"-->
          <!--                           v-model="SearchUser"-->
          <!--                           :fetch-suggestions="SearchquerySearch"-->
          <!--                           :trigger-on-focus="false"-->
          <!--                           :placeholder="$t('message').group.group_search_pleacholder"-->
          <!--                           @select="SearchshandleSelect">-->
          <!--            <i class="el-icon-search el-input__icon" slot="prefix">-->
          <!--            </i>-->
          <!--            <template slot-scope="{ item }">-->
          <!--              <div class="d-flex py-2">-->
          <!--                <el-avatar-->
          <!--                    :src="item.userinfo_id.avatar">-->
          <!--                  {{ item.userinfo_id.first_letter }}-->
          <!--                </el-avatar>-->
          <!--                <div class="pl-2">-->
          <!--                  <div class="name">{{ item.userinfo_id.username }}</div>-->
          <!--                  <span class="addr">{{ item.userinfo_id.email }}</span>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--            <el-button class="shadow-none rounded-right invite" slot="append" type="primary"-->
          <!--                       :disabled="SearchUserID===0"-->
          <!--                       @click="SearchMember">-->
          <!--              {{ $t('message').group.group_search_pleacholder}}-->
          <!--            </el-button>-->
          <!--          </el-autocomplete>-->
          <!--        </div>-->
        </div>
        <!--        退出群吧-->
        <div class="mt-4 pt-4 text-center col-md-12">
          <el-popconfirm
              v-if="$store.state.group.groupTopBar.auth==1 || $store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6"
              placement="top-end"
              confirm-button-text='退出'
              cancel-button-text='取消'
              title="确定退出这个群吧吗？"
              class="text-danger wxc-green"
              @confirm="removeMember()"
          >
            <el-button slot="reference" icon="el-icon-switch-button" class="w-100"
            >退出群吧
            </el-button>
          </el-popconfirm>
        </div>

        <!--      等待审核的用户可见-->
        <el-button icon="el-icon-switch-button" class="text-gray w-100"
                   v-if="$store.state.group.groupTopBar.auth==0"
                   command="0"
                   @click="removeMember()">取消申请
        </el-button>
      </el-dialog>
      <!--    群规对话框-->
      <!-- member list dialog -->
      <!--        :visible.sync="groupRuleTrigger"-->

      <el-dialog
          :title="$t('message').group.rule"
          :visible.sync="groupRuleTrigger"
          width="390px"
          center>
        <div style="max-height:400px;overflow-y:scroll;margin-top:-32px;overflow-x:hidden">
          <div class="py-3 shadow-none group-rule-content">
            <div v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6">
              <el-input
                  v-model="editGoupInfo.rule"
                  class="flex-fill mr-2"
                  type="textarea"
                  :rows="3"
                  placeholder="设置群规有助于确立你的群吧风格，并避免群员冲突。建议最多可以为小组设置 5 条规则。太多大家也懒得看"
              >
              </el-input>
              <div slot="footer" class="dialog-footer text-right mt-3">
                <el-button size="small" @click="groupRuleTrigger = false">取 消</el-button>
                <el-button size="small" type="primary"
                           @click="update('rule',editGoupInfo.rule)">
                  确 定
                </el-button>
              </div>
            </div>
            <div v-else>
              <div class="group-rule-content">
                <p>{{ groupState.groupTopBar.rule }}</p>
              </div>
            </div>
          </div>
          <div v-if="disabled" @click="getMoreMembers" class="text-center" role="button">查看更多群员</div>
        </div>
      </el-dialog>
      <!-- 修改信息对话框 -->
      <el-dialog
          :title="editGoupInfo.title"
          :visible.sync="editGoupInfo.is_edit"
          :width="editGoupInfo.type===1?'380px':'560px'"
          center>
        <div>
          <el-input
              v-if="editGoupInfo.type===1"
              v-model="editGoupInfo.name"
              maxlength="10"
              show-word-limit
              placeholder="请输入内容">

          </el-input>
          <el-input
              class="flex-fill mr-2" v-if="editGoupInfo.type===2"
              type="textarea"
              :rows="3"
              placeholder="请输入群吧主题"
              v-model="editGoupInfo.description">
          </el-input>
          <!--        群规-->
          <!--        <div class="py-3 shadow-none" >-->
          <!--          <div v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6">-->
          <!--            <el-input-->
          <!--                class="flex-fill mr-2"-->
          <!--                type="textarea"-->
          <!--                :rows="3"-->
          <!--                placeholder="设置群规有助于确立你的群吧风格，并避免群员冲突。"-->
          <!--                v-model="editGoupInfo.rule"-->
          <!--            >-->
          <!--            </el-input>-->
          <!--          </div>-->
          <!--          <div v-else>-->
          <!--              {{groupState.groupTopBar.rule}}-->
          <!--            &lt;!&ndash;            {{groupInfo.rule}}&ndash;&gt;-->
          <!--          </div>-->
          <!--        </div>-->
          <!--        群规-->
        </div>
        <div slot="footer" class="dialog-footer text-right">
          <el-button size="small" @click="editGoupInfo.is_edit = false">取 消</el-button>
          <el-button size="small" type="primary"
                     @click="update(editGoupInfo.type===1?'name':'description',editGoupInfo.type===1?editGoupInfo.name:editGoupInfo.description)">
            确 定
          </el-button>
        </div>
      </el-dialog>
      <!--      邀请入群dialog-->
      <login-dialog ref="dialog"></login-dialog>
    </div>
<!--        normal 待激活群主身份-->
<!--    <div class="mb-3 bg-white pt-3 pb-2"-->
<!--         style="border-radius: 15px" v-if="groupState.groupTopBar.is_activate==0 && $store.state.user.userinfo.id===groupState.groupTopBar.userID">-->
<!--      <p class="text-center mt-1">原群主, 若未点击"激活群主身份"<br>2周后群里其它群员均有机会认领此群。取代原群主</p>-->
<!--      <button style="border-radius: 20px;height: 40px"  class="post btn btn-success  d-flex justify-content-center mx-auto" size="medium" @click="GroupActivate(groupinfoID)" >-->
<!--        <i class="el-icon-s-claim" style="font-size:18px"></i>-->
<!--                <div class="d-xl-inline ml-1">激活群主身份</div>-->
<!--        &lt;!&ndash;        <div class="d-none d-xl-inline ml-1">认领此群</div>&ndash;&gt;-->
<!--      </button>-->
<!--    </div>-->
    <!--        normal 待认领群主 -->
    <div class="mb-3 bg-white pt-3 pb-2"
         style="border-radius: 15px" v-if="groupState.groupTopBar.is_claim==0 && groupState.groupTopBar.is_activate==0  && groupState.groupTopBar.userID!==2000004 && $store.state.group.groupTopBar.auth>=1">
      <!--    <div class="mb-3 bg-white pt-3 pb-2"  style="border-radius: 15px" v-if="groupState.groupTopBar.is_claim==1 && $store.state.user.userinfo.id===groupState.groupTopBar.userID && groupState.groupTopBar.create_date<1646467200">-->
      <p class="text-center mt-1">点击  "认领群主" 成为群主  机会难得，先到先得</p>
      <button style="border-radius: 20px;height: 40px"  class="post btn btn-success  d-flex justify-content-center mx-auto" size="medium" @click="GroupClaim(groupinfoID)" >
        <i class="el-icon-s-claim" style="font-size:18px"></i>
        <div class="d-xl-inline ml-1">认领群主</div>
        <!--        <div class="d-none d-xl-inline ml-1">认领此群</div>-->
      </button>
    </div>
    <!--        normal 认领管理员 -->
    <div class="mb-3 bg-white pt-3 pb-2"
         style="border-radius: 15px" v-if="groupState.groupTopBar.userID==2000004 && $store.state.group.groupTopBar.auth==1 && !groupState.groupTopBar.apply_userID.includes($store.state.user.userinfo.id) && groupState.groupTopBar.apply_userID.split(',').length<3">
      <!--    <div class="mb-3 bg-white pt-3 pb-2"  style="border-radius: 15px" v-if="groupState.groupTopBar.is_claim==1 && $store.state.user.userinfo.id===groupState.groupTopBar.userID && groupState.groupTopBar.create_date<1646467200">-->
      <p class="text-center mt-1">点击"认领管理员"申请成为管理员<br>等待群吧管理，批准后，您将成为该群管理员</p>
      <button style="border-radius: 20px;height: 40px"  class="post btn btn-success  d-flex justify-content-center mx-auto" size="medium" @click="GroupApplyManager(groupinfoID)" >
        <i class="el-icon-s-claim" style="font-size:18px"></i>
        <div class="d-xl-inline ml-1">认领管理员</div>
        <!--        <div class="d-none d-xl-inline ml-1">认领此群</div>-->
      </button>
    </div>
<!--    等待批准认领-->
    <div class="mb-3 pt-3 pb-2"
         style="border-radius: 15px" v-if="groupState.groupTopBar.userID==2000004 && groupState.groupTopBar.apply_userID.includes($store.state.user.userinfo.id)">
      <!--    <div class="mb-3 bg-white pt-3 pb-2"  style="border-radius: 15px" v-if="groupState.groupTopBar.is_claim==1 && $store.state.user.userinfo.id===groupState.groupTopBar.userID && groupState.groupTopBar.create_date<1646467200">-->
      <div style="border-radius: 20px;height: 40px"  class="post text-dark  d-flex justify-content-center mx-auto" size="medium" @click="GroupClaim(groupinfoID)" >
        <i class="el-icon-time " style="font-size:18px;margin-top: 1px"></i>
        <div class="d-xl-inline ml-1">管理员申请审核中，请耐心等待</div>
        <!--        <div class="d-none d-xl-inline ml-1">认领此群</div>-->
      </div>
    </div>
    <div class="grouper-header  d-sm-block d-none">
      <div class="d-flex align-items-center">
        <div style="width:60px;height:60px" @click="setAvatar('picInput')" class="avatar-box mr-2">
          <i class="el-icon-camera-solid"
             v-if="$store.state.user.userinfo && $store.state.group.groupTopBar.auth>=2">
          </i>
<!--          <i class="el-icon-camera-solid"-->
<!--             v-if="$store.state.user.userinfo && $store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==groupState.groupTopBar.apply_userID.id">-->
<!--          </i>-->
          <router-link :to="'/group/index/'+$store.state.group.groupTopBar.id">
            <el-avatar v-if="groupState.groupInfo.name" shape="square" :src="groupState.groupTopBar.avatar"
                       :size="60"><span
                style="font-size:36px">{{ groupState.groupInfo.name.substring(0, 1).toUpperCase() }}</span>
            </el-avatar>
          </router-link>
          <input
              ref="picInput"
              type="file"
              name="image"
              accept="image/png, image/jpeg"
              @change="setImage"
              style="display:none"
          />
        </div>
        <div v-show="show" v-if="show">
          <VueCropper v-if="imgSrc" ref="cropper" :src="imgSrc" alt="Source Image" preview=".preview"
                      :aspectRatio="1"></VueCropper>
          <div class="d-flex align-items-center">
            <button class="btn btn-simple btn-round btn-primary" @click="saveImage">
              {{ $t('message').setting.accout_avatar_save_btn }}
            </button>
            <button class="btn btn-simple btn-round btn-default ml-3" @click="toggleShow">
              {{ $t('message').setting.accout_cancel_btn }}
            </button>
          </div>
          <div class="preview"/>
        </div>
        <div>
          <a v-if="$store.state.user.check_is_wxc_domain()"
             :href="'#'">
            <!--              :href="'https://passport.wenxuecity.com/members/index.php?act=profile&cid='+$store.state.group.groupTopBar.userID.username">-->
            <!--           <el-popover-->
            <!--               placement="top-start"-->
            <!--               :width="340"-->
            <!--               trigger="hover"-->
            <!--               :open-delay="600"-->
            <!--           >-->
            <!--             <User-Infor-Card :data="data" type="small">-->
            <!--             </User-Infor-Card>-->
            <el-avatar
                class="host"
                :size="36"
                v-for="item in memberList.data.host"
                :key="item.id"
                :data="item">
              <img v-if="item.userinfo_userID.avatar!=''" :src="item.userinfo_userID.avatar">
              <div v-else> {{ item.userinfo_userID.first_letter }}</div>
            </el-avatar>
            <!--           </el-popover>-->
          </a>
          <router-link
              v-else
              :to="'/userindex/'+$store.state.group.groupTopBar.userID">
            <!--           <el-popover-->
            <!--               placement="top-start"-->
            <!--               :width="340"-->
            <!--               trigger="hover"-->
            <!--               :open-delay="600"-->
            <!--           >-->
            <!--             <User-Infor-Card :data="data" type="small">-->
            <!--             </User-Infor-Card>-->
            <el-avatar
                class="host"
                :size="36"
                v-for="item in memberList.data.host"
                :key="item.id"
                :data="item">
              <img v-if="item.userinfo_userID.avatar!=''" :src="item.userinfo_userID.avatar">
              <div v-else> {{ item.userinfo_userID.first_letter }}</div>
            </el-avatar>
            <!--           </el-popover>-->
          </router-link>
        </div>
        <!--      <div class="d-flex">-->
        <div>
          <!-- <router-link :to="'/group/user/index'" class="h3 mb-0 font-weight-bold pr-2">-->
          <div class="mb-0  pr-4">
<!--            <div class="d-inline float-left text-muted">-->
<!--&lt;!&ndash;              <router-link style="display: block" :to="'/group/new/'+groupState.groupTopBar.taginfo_tagID">&ndash;&gt;-->
<!--                {{groupState.groupTopBar.taginfo_tagID.name |textTrans }}-->
<!--&lt;!&ndash;              </router-link>&ndash;&gt;-->
<!--            </div>-->
            <div>
              <router-link style="display: block" :to="'/group/index/'+$store.state.group.groupTopBar.id">
              <span class="float-left text-dark mr-1 grouper-header-title mb-2 font-weight-bold ">
               <div class="float-left mr-1">
                  <i  v-if="groupState.groupTopBar.is_private" style="width:16px" class="el-icon-lock text-muted small"></i>
<!--                  <span v-else ><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px" height="20px" viewBox="0,0,256,256"><g fill-opacity="0.70196" fill="#000000" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M25,2c-12.6907,0 -23,10.3093 -23,23c0,12.69071 10.3093,23 23,23c12.69071,0 23,-10.30929 23,-23c0,-12.6907 -10.30929,-23 -23,-23zM24,4.11719v8.86133h-7.15625c0.37775,-1.11424 0.80451,-2.15004 1.27344,-3.08789c1.64568,-3.29136 3.73097,-5.29497 5.88281,-5.77344zM26,4.11719c2.15184,0.47847 4.23713,2.48208 5.88281,5.77344c0.46892,0.93785 0.89569,1.97365 1.27344,3.08789h-7.15625zM19.18164,4.82031c-1.07782,1.13172 -2.03889,2.54653 -2.85352,4.17578c-0.60366,1.20732 -1.12691,2.54995 -1.58008,3.98242h-6.95898c2.71982,-3.88927 6.7155,-6.81487 11.39258,-8.1582zM30.81836,4.82031c4.67708,1.34334 8.67276,4.26893 11.39258,8.1582h-6.95898c-0.45317,-1.43247 -0.97642,-2.7751 -1.58008,-3.98242c-0.81462,-1.62925 -1.7757,-3.04407 -2.85352,-4.17578zM6.51367,15.02148h7.66016c-0.67859,2.7384 -1.07268,5.77366 -1.14453,8.97852h-8.99805c0.15194,-3.23925 1.02847,-6.28731 2.48242,-8.97852zM16.23828,15.02148h7.76172v8.97852h-8.96875c0.07664,-3.23703 0.49918,-6.28968 1.20703,-8.97852zM26,15.02148h7.76172c0.70785,2.68884 1.13039,5.74148 1.20703,8.97852h-8.96875zM35.82617,15.02148h7.66016c1.45395,2.6912 2.33048,5.73926 2.48242,8.97852h-8.99805c-0.07185,-3.20485 -0.46594,-6.24012 -1.14453,-8.97852zM4.04102,26h8.98438c0.07007,3.2078 0.46964,6.23929 1.14844,8.97852h-7.6582c-1.45446,-2.69014 -2.32245,-5.73945 -2.47461,-8.97852zM15.02539,26h8.97461v8.97852h-7.76172c-0.70814,-2.68994 -1.13748,-5.73893 -1.21289,-8.97852zM26,26h8.97461c-0.07541,3.23959 -0.50475,6.28858 -1.21289,8.97852h-7.76172zM36.97461,26h8.98438c-0.15216,3.23906 -1.02015,6.28837 -2.47461,8.97852h-7.6582c0.6788,-2.73923 1.07836,-5.77071 1.14844,-8.97852zM7.79492,37.02148h6.95313c0.45317,1.43247 0.97642,2.7751 1.58008,3.98242c0.81462,1.62925 1.7757,3.04407 2.85352,4.17578c-4.67546,-1.34287 -8.66643,-4.27237 -11.38672,-8.1582zM16.84375,37.02148h7.15625v8.86133c-2.15184,-0.47847 -4.23713,-2.48208 -5.88281,-5.77344c-0.46892,-0.93785 -0.89569,-1.97365 -1.27344,-3.08789zM26,37.02148h7.15625c-0.37775,1.11424 -0.80451,2.15004 -1.27344,3.08789c-1.64568,3.29136 -3.73097,5.29497 -5.88281,5.77344zM35.25195,37.02148h6.95313c-2.72028,3.88583 -6.71126,6.81533 -11.38672,8.1582c1.07782,-1.13172 2.03889,-2.54653 2.85352,-4.17578c0.60366,-1.20732 1.12691,-2.54995 1.58008,-3.98242z"></path></g></g></svg></span>-->
                </div>
                {{groupState.groupTopBar.name |textTrans }}</span>
              </router-link>
              <div class="d-inline float-left">
                <el-tag class="mr-1 px-1 pt-0 float-left" size="small">群主</el-tag>
                <div v-for="item in memberList.data.host"
                     :key="item.id"
                     style="display: inline-block"
                >{{ item.userinfo_userID.username }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-dropdown trigger="click"
                     v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6"
                     @command="handleCommand">
            <span class="el-dropdown-link group-rule ">
<!--              <el-tooltip content="群吧设置" placement="top" effect="light">-->
               <i size="medium" class="el-icon-s-tools"></i>
                <span style="margin-left:2px">管理</span>
              <!--              </el-tooltip>-->
            </span>
          <el-dropdown-menu slot="dropdown">
            <!--              群主和超管可见-->
            <el-dropdown-item v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6"
                              icon="el-icon-edit" command="1">修改群吧名
            </el-dropdown-item>
            <el-dropdown-item v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6"
                              icon="el-icon-tickets" command="2">修改群吧主题
            </el-dropdown-item>
            <el-dropdown-item v-if="$store.state.group.groupTopBar.auth>=3"
            >
              <el-popconfirm
                  placement="top-end"
                  confirm-button-text='删除'
                  cancel-button-text='取消'
                  title="确定删除这个群吧吗？"
                  class="text-danger"
                  @confirm="removeGroup(groupID)"
              >
                <a href="javascript:void(0)" slot="reference" style="color:gray;display: block">
                  <i class="el-icon-delete"></i>
                  删除群吧
                </a>
              </el-popconfirm>
            </el-dropdown-item>
            <!--              群员和管理员可见-->
            <!--              <el-popconfirm v-if="$store.state.group.groupTopBar.auth==1 || $store.state.group.groupTopBar.auth==2"-->
            <!--                    placement="top-end"-->
            <!--                    confirm-button-text='退出'-->
            <!--                    cancel-button-text='取消'-->
            <!--                    title="确定退出这个群吧吗？"-->
            <!--                    class="text-danger wxc-green"-->
            <!--                    @confirm="removeMember()"-->
            <!--                >-->
            <!--                <el-dropdown-item slot="reference" icon="el-icon-switch-button" class="text-danger"-->
            <!--                  >退出群吧-->
            <!--                </el-dropdown-item>-->
            <!--              </el-popconfirm>-->
            <!--              &lt;!&ndash;              等待审核的用户可见&ndash;&gt;-->
            <!--              <el-dropdown-item icon="el-icon-switch-button" class="text-danger"-->
            <!--                                v-if="$store.state.group.groupTopBar.auth==0"-->
            <!--                                command="0">取消申请-->
            <!--              </el-dropdown-item>-->
            <!--              <el-dropdown-item v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6"-->
            <!--                                icon="el-icon-tickets" command="4">修改群规-->
            <!--              </el-dropdown-item>-->
          </el-dropdown-menu>
        </el-dropdown>

        <!--      <div class="group-rule  flex-fill" @click="groupRuleTrigger=true">-->
        <!--        <div class="ml-4" v-if="!groupState.groupTopBar.rule=='' || $store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6">-->
        <!--          <div class="group-rule  flex-fill" @click="groupRuleTrigger=true">-->
        <!--            <i class="el-icon-notebook-1 mr-1 trans"></i>-->
        <!--            <span>{{ $t('message').group.rule }}</span>-->
        <!--          </div>-->
        <!--        </div>-->

        <span class="h5 mb-0 text-secondary" v-if="!groupState.groupTopBar.is_private">
<!--        {{ $t('message').group.group_is_open }}-->
      </span>
        <!--      <span class="h5 mb-0 text-secondary" v-if="groupState.groupTopBar.is_private">-->
        <!--          <i class="el-icon-lock"></i>-->
        <!--           {{ $t('message').group.group_is_private }}-->
        <!--        </span>-->
        <!--        {{-->
        <!--          groupState.groupTopBar.is_private ?   $t('message').group.group_is_open  :  $t('message').group.group_is_private-->
        <!--        }}-->
        <div v-if="$store.state.group.groupTopBar.auth>=1  || $store.state.user.userinfo.UserLevel==6 || $store.state.group.groupTopBar.is_private===0" class="group-member-show h5 mb-0 flex-fill" style="padding-left:105px;cursor:pointer" @click="memberListTrigger=true">
        <span>
                       <el-avatar
                           :size="36"
                           v-for="item in memberList.data.member.slice(0,2)"
                           :key="item.id"
                           :data="item"
                       >
                         <img v-if="item.userinfo_userID.avatar!=''" :src="item.userinfo_userID.avatar">
                         <div v-else> {{ item.userinfo_userID.first_letter }} </div>
                        </el-avatar>
          <!--          item.userinfo_id.avatar-->
          <span class="text-secondary" style="font-size: 14px">{{
              groupState.groupTopBar.count_member
            }} {{ $t('message').group.group_member_unit }}</span>
        </span>
          <span v-if="has_verify && ($store.state.group.groupTopBar.auth>=2 || $store.state.user.userinfo.UserLevel==6)">
            <el-badge :value="memberList.data.verify.length || 0" class="ite ml-2" type="primary"
                      v-if="memberList.data.verify.length>0">
              <el-button class="p-1" style="font-size:18px;border:none" type="primary" plain>
                <i size="medium" class="el-icon-user-solid"></i>
              </el-button>
            </el-badge>
          </span>
        </div>
        <div v-else class="group-member-show h5 mb-0 flex-fill" style="padding-left:105px;cursor:pointer">
        <span>
                       <el-avatar
                           :size="36"
                           v-for="item in memberList.data.member.slice(0,2)"
                           :key="item.id"
                           :data="item"
                       >
                         <img v-if="item.userinfo_userID.avatar!=''" :src="item.userinfo_userID.avatar">
                         <div v-else> {{ item.userinfo_userID.first_letter }} </div>
                        </el-avatar>
          <!--          item.userinfo_id.avatar-->
          <span class="text-secondary" style="font-size: 14px">{{
              groupState.groupTopBar.count_member
            }} {{ $t('message').group.group_member_unit }}</span>
        </span>
          <span v-if="has_verify && ($store.state.group.groupTopBar.auth>=2 || $store.state.user.userinfo.UserLevel==6)">
            <el-badge :value="memberList.data.verify.length || 0" class="ite ml-2" type="primary"
                      v-if="memberList.data.verify.length>0">
              <el-button class="p-1" style="font-size:18px;border:none" type="primary" plain>
                <i size="medium" class="el-icon-user-solid"></i>
              </el-button>
            </el-badge>
          </span>
        </div>

        <div class="align-items-right" v-if="$store.state.group.groupTopBar.auth<=0">
          <button v-if="$store.state.group.groupTopBar.auth===-1 && $store.state.group.groupTopBar.is_private===1" type="button" class="btn btn-primary w-100"
                  @click="joniGroup()">{{
              $t('message').group.group_add
            }}
          </button>
          <span v-if="$store.state.group.groupTopBar.auth==0" class="h5 text-secondary mr-3">
          <i size="medium"  style="font-size: 35px;color: #2196f3"  class="el-icon-alarm-clock mr-1"></i> 待审核
        </span>
        </div>
        <div v-if="$store.state.group.groupTopBar.auth>0 || $store.state.group.groupTopBar.is_private===0">
          <button class="post btn btn-primary" icon="el-icon-edit" v-if="!show_editor" @click="show_editor=true">
            <i class="el-icon-edit" style="font-size:18px"></i>
            <div class="d-none d-xl-inline ml-1">{{ $t('message').topnav.group_editbtn }}</div>
          </button>
          <el-button type="default" icon="el-icon-close" v-if="show_editor" @click="cancle">取消</el-button>
          <el-tooltip class="item" effect="dark" content="公开群组，发帖即可成为群员" placement="left-start">
            <p style="margin-bottom: 0px;font-size: 13px;position: absolute" v-if="$store.state.group.groupTopBar.is_private===0">
              <!--              <i size="medium" data-placement="bottom" class="el-icon-warning-outline text-secondary tool el-popover__reference" aria-describedby="el-popover-6051" tabindex="0" style="margin-top: 3px; font-size: 22px; font-weight: 800; color: rgb(77, 129, 89) !important;"></i>-->
              <el-button style="padding:0;padding-left:10px" type="text">发帖即入群</el-button>
            </p>
          </el-tooltip>
        </div>
        <!--      邀请入群-->
        <!--      <div v-if="is_admin">-->
        <!-- <div>
          <el-button type="primary" plain class="ml-2" @click="openAddMemberDialog()" slot="reference">
            <i class="font-weight-bold el-icon-plus"></i> {{ $t('message').group.group_add_member }}
          </el-button>
        </div> -->
        <!--      邀请入群-->
      </div>
      <!-- Editor -->
      <div class="border-bottom groupHeadEditor" v-if="show_editor">
        <wxc-editor :data="{groupinfoID:groupState.groupTopBar.id}" :action="'add'" @submited="updated($event)"
                    @cancled="closeEditor()"></wxc-editor>
      </div>
      <!-- Editor -->
      <!-- member list dialog -->
      <el-dialog
          :title="$t('message').group.member_list_label1"
          :visible.sync="memberListTrigger"
          width="380px"
          center>
        <div style="margin-top:-32px;max-height:500px;overflow-y:auto;margin-top:-32px" v-if="this.memberList.data">
          <!--      <div style="margin-top:-32px" v-if="this.memberList.data">-->
          <div class="py-3 shadow-none"
               v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6">
            <!--          <h4 class="mb-3">邀请群员</h4>-->
            <el-autocomplete class="w-100"
                             popper-class="invite-autocomplete"
                             v-model="inviteUser"
                             :fetch-suggestions="querySearch"
                             :trigger-on-focus="false"
                             :placeholder="$t('message').groupindex.left_btn_add"
                             @select="handleSelect">
              <i class="el-icon-search el-input__icon" slot="prefix">
              </i>
              <template slot-scope="{ item }">
                <div class="d-flex py-2">
                  <el-avatar
                      :src="item.userinfo_id.avatar">
                    {{ item.userinfo_id.first_letter }}
                  </el-avatar>
                  <div class="pl-2">
                    <div class="name">{{ item.userinfo_id.username }}</div>
                    <span class="addr">{{ item.userinfo_id.email }}</span>
                  </div>
                </div>
              </template>
              <el-button class="shadow-none rounded-right invite" slot="append" type="primary"
                         :disabled="inviteUserID===0"
                         @click="inviteMember">
                {{ $t('message').group.group_add_member }}
              </el-button>
            </el-autocomplete>
          </div>
          <!--      <div>-->
          <div>
            <h4 v-if="memberList.data.verify && memberList.data.verify.length>0">
              <!--            <h4 v-if="memberList.data.verify && memberList.data.verify.length>0">-->
              {{ $t('message').group.member_list_label0 }} <span
                style="color:grey;font-size:17px">
           . {{ memberList.data.verify.length || 0 }}
          </span>
            </h4>
            <div
                v-if="has_verify && $store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6">
              <Member-list-item
                  v-for="item in memberList.data.verify"
                  :key="item.id"
                  type="verify"
                  :data="item"
                  @opendialog="$refs.dialog()">
              </Member-list-item>
            </div>
          </div>
          <div>
            <Member-list-item
                v-for="item in memberList.data.host"
                :key="item.id"
                :data="item"
                type="host"
                @opendialog="$refs.dialog()">
            </Member-list-item>
            <Member-list-item
                v-for="item in memberList.data.admin"
                :key="item.id"
                :data="item"
                type="admin"
                @opendialog="$refs.dialog()">
            </Member-list-item>
            <div v-infinite-scroll="getMoreMembers"
                 infinite-scroll-disabled="disabled"
                 infinite-scroll-distance="50">
                <Member-list-item
                    v-for="item in memberList.data.member"
                    :key="item.id"
                    :data="item"
                    type="member"
                    @opendialog="$refs.dialog()">
                </Member-list-item>
            </div>
          </div>
          <div v-if="this.groupState.memberLists.length>40" @click="getMoreMembers"  class="text-center mt-2 mb-2" role="button">
            点击查看更多群员
            <i class="ml-2 el-icon-arrow-down"></i>
          </div>
          <div v-else class="text-center mt-2 mb-2" role="button" >就这些个人儿了
          </div>
          <!--        查找群员-->
          <!--        <div class="py-3 shadow-none"  v-if="memberList.data.member.length>2">-->
          <!--          &lt;!&ndash;          <h4 class="mb-3">邀请群员</h4>&ndash;&gt;-->
          <!--          <el-autocomplete class="w-100"-->
          <!--                           popper-class="invite-autocomplete"-->
          <!--                           v-model="SearchUser"-->
          <!--                           :fetch-suggestions="SearchquerySearch"-->
          <!--                           :trigger-on-focus="false"-->
          <!--                           :placeholder="$t('message').group.group_search_pleacholder"-->
          <!--                           @select="SearchshandleSelect">-->
          <!--            <i class="el-icon-search el-input__icon" slot="prefix">-->
          <!--            </i>-->
          <!--            <template slot-scope="{ item }">-->
          <!--              <div class="d-flex py-2">-->
          <!--                <el-avatar-->
          <!--                    :src="item.userinfo_id.avatar">-->
          <!--                  {{ item.userinfo_id.first_letter }}-->
          <!--                </el-avatar>-->
          <!--                <div class="pl-2">-->
          <!--                  <div class="name">{{ item.userinfo_id.username }}</div>-->
          <!--                  <span class="addr">{{ item.userinfo_id.email }}</span>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--            <el-button class="shadow-none rounded-right invite" slot="append" type="primary"-->
          <!--                       :disabled="SearchUserID===0"-->
          <!--                       @click="SearchMember">-->
          <!--              {{ $t('message').group.group_search_pleacholder}}-->
          <!--            </el-button>-->
          <!--          </el-autocomplete>-->
          <!--        </div>-->
        </div>
        <!--        退出群吧-->
        <div class="mt-4 pt-4 text-center col-md-12">
          <el-popconfirm
              v-if="$store.state.group.groupTopBar.auth==1 || $store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6"
              placement="top-end"
              confirm-button-text='退出'
              cancel-button-text='取消'
              title="确定退出这个群吧吗？"
              class="text-danger wxc-green"
              @confirm="removeMember()"
          >
            <el-button slot="reference" icon="el-icon-switch-button" class="w-100"
            >退出群吧
            </el-button>
          </el-popconfirm>
        </div>

        <!--      等待审核的用户可见-->
        <el-button icon="el-icon-switch-button" class="text-gray w-100"
                   v-if="$store.state.group.groupTopBar.auth==0"
                   command="0"
                   @click="removeMember()">取消申请
        </el-button>
      </el-dialog>
      <!--    群规对话框-->
      <!-- member list dialog -->
      <!--        :visible.sync="groupRuleTrigger"-->

      <el-dialog
          :title="$t('message').group.rule"
          :visible.sync="groupRuleTrigger"
          width="380px"
          center>
        <div style="max-height:400px;overflow-y:scroll;margin-top:-32px;overflow-x:hidden">
          <div class="py-3 shadow-none group-rule-content">
            <div v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6">
              <el-input
                  v-model="editGoupInfo.rule"
                  class="flex-fill mr-2"
                  type="textarea"
                  :rows="3"
                  placeholder="设置群规有助于确立你的群吧风格，并避免群员冲突。建议最多可以为小组设置 5 条规则。太多大家也懒得看"
              >
              </el-input>
              <div slot="footer" class="dialog-footer text-right mt-3">
                <el-button size="small" @click="groupRuleTrigger = false">取 消</el-button>
                <el-button size="small" type="primary"
                           @click="update('rule',editGoupInfo.rule)">
                  确 定
                </el-button>
              </div>
            </div>
            <div v-else>
              <div class="group-rule-content">
                <p>{{ groupState.groupTopBar.rule }}</p>
              </div>
            </div>
          </div>
          <div v-if="!this.groupState.memberList.data.nomore" @click="getMoreMembers" class="text-center" role="button">查看更多群员</div>
        </div>
      </el-dialog>
      <!-- 修改信息对话框 -->
      <el-dialog
          :title="editGoupInfo.title"
          :visible.sync="editGoupInfo.is_edit"
          :width="editGoupInfo.type===1?'380px':'560px'"
          center>
        <div>
          <el-input
              v-if="editGoupInfo.type===1"
              v-model="editGoupInfo.name"
              maxlength="10"
              show-word-limit
              placeholder="请输入内容">

          </el-input>
          <el-input
              class="flex-fill mr-2" v-if="editGoupInfo.type===2"
              type="textarea"
              :rows="3"
              placeholder="请输入群吧主题"
              v-model="editGoupInfo.description">
          </el-input>
          <!--        群规-->
          <!--        <div class="py-3 shadow-none" >-->
          <!--          <div v-if="$store.state.group.groupTopBar.auth>=2  || $store.state.user.userinfo.UserLevel==6">-->
          <!--            <el-input-->
          <!--                class="flex-fill mr-2"-->
          <!--                type="textarea"-->
          <!--                :rows="3"-->
          <!--                placeholder="设置群规有助于确立你的群吧风格，并避免群员冲突。"-->
          <!--                v-model="editGoupInfo.rule"-->
          <!--            >-->
          <!--            </el-input>-->
          <!--          </div>-->
          <!--          <div v-else>-->
          <!--              {{groupState.groupTopBar.rule}}-->
          <!--            &lt;!&ndash;            {{groupInfo.rule}}&ndash;&gt;-->
          <!--          </div>-->
          <!--        </div>-->
          <!--        群规-->
        </div>
        <div slot="footer" class="dialog-footer text-right">
          <el-button size="small" @click="editGoupInfo.is_edit = false">取 消</el-button>
          <el-button size="small" type="primary"
                     @click="update(editGoupInfo.type===1?'name':'description',editGoupInfo.type===1?editGoupInfo.name:editGoupInfo.description)">
            确 定
          </el-button>
        </div>
      </el-dialog>
      <!--      邀请入群dialog-->
      <login-dialog ref="dialog"></login-dialog>
    </div>
  </div>
</template>
<script>
// import MyEditor from '@/module/blog/pages/editor/Index.vue'
import WxcEditor from '../../editor/index.vue';
import MemberListItem from '@/module/group/pages/components/Main/MemberListItem.vue';
import LoginDialog from '@/module/user/login/LoginDialog';
import {textTrans} from '@/directives/textTrans.js';
import {Popconfirm} from 'element-ui';
import 'cropperjs/dist/cropper.css';
import VueCropper from 'vue-cropperjs';
import group from '@/module/group/group.service';
// import UserInforCard from '@/module/user/components/UserInforCard';

export default ({
  name: 'group-header',
  props: {
    // data: {},
    // memberList: {},
    groupID: Number
    // groupID:String
  },
  components: {
    MemberListItem,
    WxcEditor,
    LoginDialog,
    [Popconfirm.name]: Popconfirm,
    VueCropper,
    // UserInforCard
  },
  watch: {
    'groupID': function (val) {
      this.init(val)
    },
  },
  created() {
    this.init(this.groupID);
    // console.log(this)
    // console.log(this)
  },
  computed: {
    disabled() {
      return this.groupState.memberList.data.nomore
    },
    not_member() {
      let fb = true
      if (!this.$store.state.user.userinfo.id) {
        fb = true
      }
      this.groupState.memberLists.forEach(x => {
        if (this.$store.state.user.userinfo.id === x.userID) {
          fb = false
        }
      });
      return fb
    },
    has_verify() {
      if (this.groupState.memberList.data.verify) {
        return this.groupState.memberList.data.verify.length > 0 ? true : false
      }
      return false
    },
  },
  methods: {
    init(groupID) {
      this.$store.dispatch('group/getGroupTopBar', groupID);
      this.$store.dispatch('group/getMemberList', {groupID: groupID, lastID: 0});

    },
    getMoreMembers() {
      this.$store.dispatch('group/getMemberList', {groupID: this.groupID, lastID: this.groupState.memberList.lastID});
    },
    openEditGoupInfo(t) {
      this.editGoupInfo.is_edit = true;
      this.editGoupInfo.type = t;
      this.editGoupInfo.name = this.groupState.groupTopBar.name;
      this.editGoupInfo.description = this.groupState.groupTopBar.description;
      this.editGoupInfo.rule = this.groupState.groupTopBar.rule;
      if (t === 1) {
        this.editGoupInfo.title = "修改群吧名";
      }
      if (t === 2) {
        this.editGoupInfo.title = "修改群吧主题"
      }
    },
    handleCommand(command) {
      switch (command) {
        case '1':
          this.openEditGoupInfo(1);
          break;
        case '2':
          this.openEditGoupInfo(2);
          break;
        case '0':
          break;
      }
    },
    update(field, value) {
      this.$store.dispatch('group/updateGroupInfo', {
        groupinfoID: this.groupState.groupTopBar.id,
        field: field,
        value: value
      }).then(res => {
        this.editGoupInfo.is_edit = false;
        this.groupRuleTrigger = false;
      })
    },
    closeEditor() {
      this.show_editor = false
      this.$message.success('发帖已取消');
    },
    removeMember() {
      this.$store.dispatch('group/removeMember', {
        groupinfoID: this.groupID,
        userID: this.$store.state.user.userinfo.id
      }).then(res => {
        this.$store.dispatch('group/getGroupTopBar', this.groupID);
        this.$store.dispatch('group/GetGroupJoinList');
        this.$router.push('/group/index/' + this.groupID);
        this.memberListTrigger = false;
        this.$message.success('您已退出此群吧');
      })
    },
    removeGroup(groupID) {
      this.$store.dispatch('group/removeGroup', groupID).then(res => {
        if (res.status) {
          // 获取我创建的群吧
          this.$store.dispatch('group/GetGroupList');
          this.$message.success('此群吧已删除');
          this.$router.push('/group/');
          setTimeout(()=>{
            location. reload();
          },300)
        } else {
          // console.log(res.msg)
        }
      })
    },
    GroupActivate() {
      group.group_activate(this.groupinfoID=this.groupID).then(res=>{
        if (res.status) {
            this.$message.success('恭喜您已经激活成功，好好经营您的群吧！');
            setTimeout(()=>{
              location. reload();
            },1000)
        } else {
          this.$message.warning(res.error);
          location. reload();
        }
      })
    },
    GroupClaim() {
      group.group_claim(this.groupinfoID=this.groupID).then(res=>{
        if (res.status) {
            this.$message.success('认领成功，您已经是群主了！');
            setTimeout(()=>{
              location. reload();
            },1000)
        } else {
          this.$message.warning(res.error);
          location. reload();
        }
      })
    },
    GroupApplyManager() {
      group.group_apply_manager(this.groupinfoID=this.groupID).then(res=>{
        if (res.status) {
          this.$message.success('申请已发送，请耐心等待群吧管理批准！');
          setTimeout(()=>{
            location. reload();
          },1000)
        } else {
          this.$message.warning(res.error);
          // location. reload();
        }
      })
    },
    joniGroup() {
      if (!this.check_user_login()) return;
      this.$store.dispatch('group/joniGroup', this.groupID).then(res => {
        if (res.status) {
          if (this.groupState.groupTopBar.is_private === 1) {
            this.$message.success('您的申请已经提交，请留意悄悄话中的社情审批结果。')
            this.joinBtnStatus = 1;
          }
          if (this.groupState.groupTopBar.is_private === 0) {
            this.$message.success('恭喜您已经加入群吧，发个帖子吧！');
          }
          this.$store.dispatch('group/getGroupTopBar', this.groupID);
          this.$store.dispatch('group/GetGroupJoinList');
          this.$router.push('/group/index/' + this.groupID);

        } else {
          this.$message.warning(res.error);
        }
      })
    },

    //查找
    openSearchMemberDialog() {
      this.SearchMemberDialog = true;
      this.SearchUser = '';
      this.SearchUserID = 0;
    },
    SearchquerySearch(queryString, cb) {
      if (queryString !== '') {
        this.SearchUserID = 0;
        this.memberList.data.host.concat(memberList.data.member)(queryString).then(res => {
          if (res.status) {
            cb(res.data);
          }
        })
      }
    },
    SearchhandleSelect(item) {
      this.inviteUser = item.userinfo_id.username;
      this.inviteUserID = item.id;
    },
    SearchMember(userID) {
      if (this.inviteUserID) {
        this.$store.dispatch('group/GroupInvite', {
          groupinfoID: this.groupState.groupTopBar.id,
          userID: this.inviteUserID
        }).then(res => {
          if (res.status) {
            this.$message.success("您的邀请已发送！");
            this.sendQqh(this.inviteUserID, `欢迎加入！您已被邀请加入了<a href="/group/index/${this.groupState.groupTopBar.id}">${this.groupState.groupTopBar.name}</a> `);
          } else {
            this.$message.warning(res.error);
          }

          this.inviteUser = '';
          this.inviteUserID = 0;
          this.addMemberDialog = false;
          this.init(this.groupID)
          // this.$store.dispatch('group/getMemberList', {
          //   groupID: this.groupID,
          //   lastID: this.$store.state.group.memberList.lastID
          // });
        })
      }
    },
    //邀请
    openAddMemberDialog() {
      this.addMemberDialog = true;
      this.inviteUser = '';
      this.inviteUserID = 0;
    },
    querySearch(queryString, cb) {
      if (queryString !== '') {
        this.inviteUserID = 0;
        this.$store.state.user.public_search_user(queryString).then(res => {
          if (res.status) {
            cb(res.data);
          }
        })
      }
    },
    handleSelect(item) {
      this.inviteUser = item.userinfo_id.username;
      this.inviteUserID = item.id;
    },
    inviteMember(userID) {
      if (this.inviteUserID) {
        this.$store.dispatch('group/GroupInvite', {
          groupinfoID: this.groupState.groupTopBar.id,
          userID: this.inviteUserID
        }).then(res => {
          if (res.status) {
            this.$message.success("您的邀请已发送！");
            this.sendQqh(this.inviteUserID, `欢迎加入！您已被邀请加入了<a href="/group/index/${this.groupState.groupTopBar.id}">${this.groupState.groupTopBar.name}</a> `);
          } else {
            this.$message.warning(res.error);
          }

          this.inviteUser = '';
          this.inviteUserID = 0;
          this.addMemberDialog = false;
          this.init(this.groupID)
          // this.$store.dispatch('group/getMemberList', {
          //   groupID: this.groupID,
          //   lastID: this.$store.state.group.memberList.lastID
          // });
        })
      }
    },
    sendQqh(touserID, msg) {
      if (!this.check_user_login()) return;
      this.$store.state.user.sendQqh(touserID, msg).then(res => {
      }).catch(err => {
        // console.log(err.error)
      })
    },
    updated(res) {
      if (res.status) {
        this.show_editor = false;
      } else {
        alert(res.error)
      }
    },
    setAvatar(name) {
      if (this.$store.state.group.groupTopBar.auth > 1) {
        this.$refs[name].click();
      }
    },
    setImage(e) {
      this.toggleShow();
      this.setImg(e);
    },
    toggleShow() {
      this.show = !this.show;
    },
    setImg(e, name = "picInput") {
      const file = e.target.files[0];
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          // if(name == "picInput")
          this.$refs.cropper.replace(event.target.result);
          // else
          //    this.$refs.cropperbg.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
      this.$refs[name].value = "";
    },
    saveImage() {
      const cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.$store.dispatch('group/updateGroupInfo', {
        groupinfoID: Number(this.$route.params.id),
        field: 'avatar',
        value: cropedImage
      }).then(res => {
        this.toggleShow();
        // this.$router.go(0)
        this.$message({message: '群吧头像修改成功', type: 'success'})
      }).catch(err => {

      })
    },
    cancle() {
      this.show_editor = false;
      this.$message({message: '已取消发帖', type: 'success'})
    },
  },
  data() {
    return {
      // userID: this.$store.state.user.userinfo.id,
      groupState: this.$store.state.group,
      memberList: this.$store.state.group.memberList,
      memberListTrigger: false,
      groupRuleTrigger: false,
      editGoupInfo: {
        is_edit: false,
        title: '',
        name: '',
        type: 1,
        rule: '',
        description: ''
      },
      show_editor: false,
      addMemberDialog: false,
      SearchMemberDialog: false,
      inviteUser: '',
      inviteUserID: 0,
      SearchUser: '',
      SearchUserID: 0,
      //joinBtnStataus -- 0: 加入 1: 待审核 2: 已加入
      joinBtnStatus: 0,
      member: '',
      length: 0,
      show: false,
      imgSrc: false,
    }
  },
  filters: {
    textTrans(string) {
      return textTrans(string);
    }
  },
  mounted: function () {

  },
})
</script>
<style>
.groupHeadEditor {
  height: 550px !important;
}


.el-button.invite {
  border-radius: 0;
  height: 41px;
  font-size: 18px;
}

.el-dropdown-menu__item {
  font-size: 17px;
  line-height: 38px;
}

.grouper-header {
  background: #fff;
  padding: 15px 15px;
  -webkit-box-shadow: 0 1px 3px rgb(18 18 18 / 10%);
  box-shadow: 0 1px 3px rgba(18, 18, 18, .1);
  border: 1px solid #9e9e9e38;
  /*background: -webkit-gradient(linear, left top, left bottom, from(#3cc3f90f), to(rgb(255 255 255)));*/
  /*background: linear-gradient(180deg, #3cc3f905, rgb(255 255 255));*/
}


.grouper-header-title {
  font-size: 19px;
  max-width: 205px;
  word-wrap: break-word;
  /*vertical-align: -webkit-baseline-middle;*/
}

.grouper-header .host {
  margin-left: -21px;
  margin-top: 44px;
  border: 2px solid #fff;
  border-radius: 50%;
  z-index: 10;
  position: relative;

}

.group-rule-content p {
  font-size: 18px;
}

.group-member-show .el-avatar {
  border: 2px solid #fff;
  margin-left: -22px;
  margin-bottom: -10px;
  position: relative;
  z-index: 10;
}

/*.group-member-show span{*/
/* color:#65676b*/
/*}*/
.el-icon-camera-solid {
  display: none;
  position: absolute;
  font-size: 38px;
  color: white;
  width: 60px;
  height: 60px;
  background: #14141480;
  text-align: center;
  line-height: 68px;
}

.el-icon-camera-solid:hover {
  cursor: pointer;
}

.group-rule {
  font-size: 20px;
  color: #0485b9;
  cursor: pointer;
}

.group-rule i {
  font-size: 25px;
  padding-top: 10px;
}

.group-rule i.trans {
  transform: rotate(351deg);
}

.group-rule span {
  padding-top: 10px;
  vertical-align: text-top;
  font-size: 14px;
  font-weight: normal;
}

.groupHeadEditor .tox-tinymce {
  height: calc(100% - 130px) !important;
}

.el-button {
  font-size: 16px;
}

.el-icon-setting {
  /*color: #175199;*/
  color: #0485b9;
  font-size: 1.6rem;
}

.el-icon-setting:hover {
  /*background: #3ab7eb1f;*/
  /*margin: 6px;*/
  /*border-radius: 5px;*/
  backgroud-color: #333;
}

.post el-button--primary, .post el-button--primary.is-plain:focus, .post el-button--primary.is-plain:hover {

  background-image: linear-gradient(-25deg, #00bcd4, #009cde);
  border-color: #03a1dc;
  -webkit-box-shadow: 0 2px 4.8px .3px rgb(0 0 0/15%);
  box-shadow: 0 2px 4.8px .3px rgb(0 0 0/15%)
}

.post el-button--primary:focus, .post el-button--primary:hover {
  color: #fff;
  background-image: linear-gradient(-94deg, #00bcd4, #009cde);
  border-color: #03a1dc;
  -webkit-box-shadow: 0 2px 4.8px .3px rgb(0 0 0/15%);
  box-shadow: 0 2px 4.8px .3px rgb(0 0 0/15%)
}
</style>
